import React, { Component } from "react";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import CopyToClipboard from "react-copy-to-clipboard";
import { FETCH_STATUS } from "../constants";
import { stateToHTML } from "draft-js-export-html";
import { convertToHTML } from "draft-convert";
import Editor from "./Editor";
import { convertLineBreaks } from "../utils";
import he from "he";
import sanitizeHtml from "sanitize-html";
import TruncatedTextBox from "./TruncatedTextBox";

const stripHtmlTags = text => text.replace(/<(?:.|\n)*?>/gm, "");

const stripNewline = text => text.replace(/(\r\n|\n|\r)/gm, "");

function CopyToClipboardDiv(containerid) {
  if (document.selection) {
    var range = document.body.createTextRange();
    range.moveToElementText(document.getElementById(containerid));
    range.select().createTextRange();
    document.execCommand("copy");
  } else if (window.getSelection) {
    var range = document.createRange();
    range.selectNode(document.getElementById(containerid));
    window.getSelection().addRange(range);
    document.execCommand("copy");
  }
}

const options = {
  styleToHTML: style => {
    if (style === "UNDERLINE") {
      return <span style={{ textDecoration: "underline" }} />;
    }
  },
  entityToHTML: (entity, originalText) => {
    if (entity.type === "LINK") {
      return (
        <a target={entity.data.target} href={entity.data.url}>
          {originalText}
        </a>
      );
    }
    return originalText;
  }
};

class Product extends Component {
  state = {
    saved: false,
    saved2: false,
    showHtml: false
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.editorState !== nextProps.editorState) {
      this.setState({ saved: false, saved2: false });
    }
  }

  onClick = () => {
    this.setState({ saved: true });
  };

  onClickNew = () => {
    CopyToClipboardDiv("newTextEditorValue");
    this.setState({ saved2: true });
  };

  render() {
    const {
      status,
      name,
      url,
      id,
      onEditorStateChange,
      editorState,
      products
    } = this.props;
    return (
      <div className="main-content">
        <div className="product-header">
          {status !== FETCH_STATUS.REQUESTED &&
            status !== FETCH_STATUS.NOT_STARTED && (
              <div>
                <h3>{name}</h3>
                <div>
                  <a
                    href={`https://www.teacherspayteachers.com/${url}`}
                    target="_blank"
                  >
                    View on TPT
                  </a>
                  | {" "}
                  <CopyToClipboard
                    text={convertLineBreaks(
                      stripNewline(
                        he.decode(
                          he.decode(
                            convertToHTML(options)(
                              editorState.getCurrentContent()
                            )
                          )
                        )
                      )
                    )}
                    onCopy={() => this.setState({ saved: true })}
                  >
                    <a
                      href="#"
                      className="link"
                      onClick={this.onClick}
                    >
                      {this.state.saved
                        ? "Copied to clipboard"
                        : " Export to HTML"}
                    </a>
                  </CopyToClipboard>{" "}
                </div>
              </div>
            )}
        </div>
        {status === FETCH_STATUS.REQUESTED && "Loading ..."}
        {status !== FETCH_STATUS.REQUESTED &&
          status !== FETCH_STATUS.NOT_STARTED && (
            <div>
              <Editor
                products={this.props.products}
                onChange={this.onChange}
                onEditorStateChange={onEditorStateChange}
                editorState={editorState}
                onFilter={this.props.onFilter}
                filterText={this.props.filterText}
              />
              <div>
                <div className="flex space-between">
                  <button
                    style={{
                      justifyContent: "space-between"
                    }}
                    className="button-primary"
                    onClick={this.onClickNew}
                  >
                    {this.state.saved2
                      ? "Copied to clipboard"
                      : "Save to new TPT Editor (no html)"}
                  </button>

                </div>
                {(this.state.saved || this.state.saved2) && (
                  <div>
                    <ul>
                      <li>
                        {id == 1 ? (
                          <a
                            href="https://www.teacherspayteachers.com/My-Products/New/Digital"
                            target="_blank"
                          >
                            Upload new Product
                          </a>
                        ) : (
                          <a
                            target="_blank"
                            href={`https://www.teacherspayteachers.com/itemsDigital/edit/${id}`}
                          >
                            Go to Edit Page of {name}
                          </a>
                        )}
                      </li>
                      <li>The HTML code has been copied to your clipboard. </li>
                      {id != 1 && (
                        <li>
                          Remove the existing description in the edit page
                        </li>
                      )}

                      <li>Paste in the new description</li>
                    </ul>
                  </div>
                )}
              </div>
              <div
                id="newTextEditorValue"
                style={{
                  translateX: -4000,
                  position: "fixed",
                  top: -2000,
                  left: -2000,
                  width: 1000,
                  height: 100
                }}
                dangerouslySetInnerHTML={{
                  __html: stripNewline(
                    he.decode(
                      he.decode(
                        convertToHTML(options)(editorState.getCurrentContent())
                      )
                    )
                  )
                }}
              />
            </div>
          )}
      </div>
    );
  }
}
export default Product;



// WEBPACK FOOTER //
// ./src/components/Product.js